
<ci-fab-button 
  class="incidents-reporter-button"
  class-name="ci-btn-primary-filled" 
  type="button" 
  icon-name="informacion-y-servicios" 
  aria-label="Reportar Incidente"
  (click)="openBottomSheet()"
  (mouseenter)="prefetchSurveyData()"
>
  <span class="incidents-reporter-button__label ci-paragraph-p1-semibold">
    {{ 'Enviar comentarios' | translate }}
  </span>
</ci-fab-button>